import React , { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import {
  PULSE_DURATION, PLAN_TYPE
} from "../../../utilities/constant";

import { FaPlus  } from 'react-icons/fa';

/** Max fractional digits allowed in Pulse Price (paisa) field */
export const MAX_PULSE_PRICE_DECIMALS = 4;

export default function RenderVoicePlanForm(props) {
  const [error, setError] = useState("");
  const [planNameError, setPlanNameError] = useState("");
  const currentValue = props.userPulseDuration || 1;
  
  // Pass planNameError to parent component
  useEffect(() => {
    if (props.setPlanNameError) {
      props.setPlanNameError(planNameError);
    }
  }, [planNameError, props]);
  const filteredDurations = PULSE_DURATION.filter(item => item.value >= currentValue);
  const [priceError, setPriceError] = useState("");
  const [durationError, setDurationError] = useState("");
  const [pulsePriceError, setpulsePriceError] = useState("");
  const filteredPlan = PLAN_TYPE.filter(item => !props.currentPlan.includes(item.value));

  const handleAddPlan = () => {
    let isValid = true;

    // Check for plan name validation errors
    if (planNameError) {
      isValid = false;
    }

    if (!props.pulsePrice) {
      setPriceError("Pulse Price is required");
      setpulsePriceError("");
      isValid = false;
    } else {
      // Validate decimal places
      const numValue = parseFloat(props.pulsePrice);
      if (isNaN(numValue)) {
        setPriceError("Pulse Price must be a valid number");
        setpulsePriceError("");
        isValid = false;
      } else {
        // Check if more than 4 decimal places
        const decimalParts = props.pulsePrice.toString().split('.');
        if (decimalParts.length > 1 && decimalParts[1].length > MAX_PULSE_PRICE_DECIMALS) {
          setpulsePriceError(
            `Pulse price can only have up to ${MAX_PULSE_PRICE_DECIMALS} decimal places`,
          );
          setPriceError("");
          isValid = false;
        } else {
          setPriceError("");
          setpulsePriceError("");
        }
      }
    }
    if (props.planType !== 'MISSED') {
      if (!props.pulseDuration || props.pulseDuration === "0") {
        setDurationError("Pulse Duration is required");
        isValid = false;
      } else {
        setDurationError("");
      }
    }

    if (!isValid) return;

    // Convert pulse_price to number and ensure it's valid
    const pulsePriceNum = parseFloat(props.pulsePrice);
    if (isNaN(pulsePriceNum)) {
      setPriceError("Pulse Price must be a valid number");
      return;
    }

    const newPlan = {
      pulse_price: pulsePriceNum, // Convert to number
      pulse_duration: Number(props.pulseDuration), // Convert to number
      plan_type : props.planType
    };
    props.setCurrentPlan((prev) => [...prev, props.planType]);
    props.setPlansData((prevData) => [...prevData, newPlan]);
    props.setPulseDuration("0");
    props.setPulsePrice("");
    props.setPlanType("")
  };

  return (
    <>
      <div className="row">
        <Form.Group className="col-md-4 form-group">
            <Form.Label htmlFor="status">Plan Name <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          <Form.Control
            type="text"
            id="planName"
            value={props.planName}
            placeholder="Plan Name"
            onChange={(e) => {
              const value = e.target.value;
              if (!/^[a-zA-Z0-9-_]*$/.test(value)) {
                setPlanNameError("Only letters, numbers, hyphen (-), and underscore (_) are allowed");
              } else {
                setPlanNameError("");
              }
              props.setPlanName(value);
            }}
          />
          {planNameError && <small className="text-danger">{planNameError}</small>}
        </Form.Group>
        <Form.Group className="col-md-4 form-group">
            <Form.Label htmlFor="call_type">Select Call Type: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          <Form.Select
            id="call_type"
            className="p-2"
            value={props.planType}
            onChange={(e) => {
              props.setPlanType(e.target.value);
              props.setPulsePrice("");
              setpulsePriceError("");
              setError("");
            }}
          >
            <option value="">Select Call Type</option>
            {filteredPlan.map(function (val, idx) {
                return (
                  <option key={idx} value={val.value}>
                    {val.label}
                  </option>
                );
              })}
          </Form.Select>
        </Form.Group>
      </div>
      {props.planType && (
        <div className= "row" style={{ alignItems: "flex-end" }}>  
          {(props.planType !== 'MISSED') && (
            <Form.Group className="col-md-4 form-group">
                <Form.Label htmlFor="status">Select Pulse Duration:<span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
              <Form.Select
                id="plan_name"
                value={props.pulseDuration}
                className="p-2"
                onChange={(e) => props.setPulseDuration(e.target.value)}
              >
                <option value={0}>Select Pulse Duration</option>
                {PULSE_DURATION.map(function (val, idx) {
                  return (
                    <option key={idx} value={val.value}>
                      {val.label}
                    </option>
                  );
                })}
              </Form.Select>
              {durationError && <small className="text-danger">{durationError}</small>}
            </Form.Group>
          )}
          
          <Form.Group className="col-md-4 form-group">
            <Form.Label htmlFor="status">Pulse Price (paisa)<span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
            <Form.Control
              type="text"
              inputMode="decimal"
              id="pulsePrice"
              className={pulsePriceError ? "is-invalid" : undefined}
              value={String(props.pulsePrice ?? "")}
              placeholder="Pulse Price"
              onChange={(e) => {
                let value = e.target.value;
                if (!/^\d*\.?\d*$/.test(value)) return;

                const decimalParts = value.split(".");
                if (
                  decimalParts.length > 1 &&
                  decimalParts[1].length > MAX_PULSE_PRICE_DECIMALS
                ) {
                  setpulsePriceError(
                    `Pulse price can only have up to ${MAX_PULSE_PRICE_DECIMALS} decimal places`,
                  );
                  return;
                }

                if (value !== "" && value !== "." && Number(value) > 1000) return;

                setpulsePriceError("");
                setPriceError("");

                props.setPulsePrice(value);
              }}
              onBlur={(e) => {
                const raw = e.target.value?.trim() ?? "";
                if (!raw) {
                  setpulsePriceError("");
                  return;
                }
                const numValue = parseFloat(raw);
                if (Number.isNaN(numValue)) return;
                const frac = raw.includes(".") ? raw.split(".")[1] : "";
                if (frac.length > MAX_PULSE_PRICE_DECIMALS) {
                  props.setPulsePrice(numValue.toFixed(MAX_PULSE_PRICE_DECIMALS));
                } else {
                  props.setPulsePrice(raw);
                }
                setpulsePriceError("");
              }}
            />
            {(pulsePriceError || priceError) && (
              <small className="text-danger d-block mt-1" role="alert">
                {pulsePriceError || priceError}
              </small>
            )}
          </Form.Group>
          <Form.Group className="col-md-4 form-group" style={{ display: "flex", alignItems: "flex-end" }}>
            <div
              style={{
                background: planNameError ? "#6c757d" : "#007bff",
                color: "white",
                width: "50px",
                height: "38px",
                borderRadius: "4px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: planNameError ? "not-allowed" : "pointer",
                opacity: planNameError ? 0.6 : 1,
              }}
              onClick={planNameError ? undefined : handleAddPlan}
            >
              <FaPlus fontSize="18px" />
            </div>
          </Form.Group>
      </div>
      )}
    </>
  );
}
